"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.stimulus = exports.generateImageChoices = void 0;
exports.handleButtonFeedback = handleButtonFeedback;
const plugin_html_multi_response_1 = __importDefault(require("@jspsych-contrib/plugin-html-multi-response"));
const __1 = require("../../..");
const helpers_1 = require("../../shared/helpers");
const trials_1 = require("../../shared/trials");
const taskSetup_1 = require("../../taskSetup");
const taskStore_1 = require("../../../taskStore");
const helpers_2 = require("../../shared/helpers");
const shouldTerminateCat_1 = require("../../shared/helpers/shouldTerminateCat");
const displayDebugInfo_1 = require("../../shared/helpers/displayDebugInfo");
const replayButtonHtmlId = 'replay-btn-revisited';
let incorrectPracticeResponses = [];
let startTime;
let selection = null;
let selectionIdx = null;
let currentTrialId = ''; // used to prevent audio from overlapping between trials
const SELECT_CLASS_NAME = 'info-shadow';
const generateImageChoices = (choices) => {
    return choices.map((choice) => {
        const imageUrl = __1.mediaAssets.images[(0, helpers_1.camelize)(choice)];
        return `<img src=${imageUrl} alt=${choice} />`;
    });
};
exports.generateImageChoices = generateImageChoices;
function enableBtns(btnElements) {
    btnElements.forEach((btn) => btn.removeAttribute('disabled'));
}
function getTestDimensionsHtml(stim) {
    const prompt = typeof stim.audioFile === 'string'
        ? (0, helpers_1.camelize)(stim.audioFile)
        : stim.audioFile.map((file) => (0, helpers_1.camelize)(file)).join(' ');
    const t = (0, taskStore_1.taskStore)().translations;
    return `
        <div class="lev-stimulus-container">
          ${(0, helpers_1.getParticipantUtilityButtonsHtml)(replayButtonHtmlId)}
          <div class="lev-row-container instruction">
            <p>${t[prompt]}</p>
          </div>
        </div>`;
}
function getSomethingSameHtml(stim) {
    const t = (0, taskStore_1.taskStore)().translations;
    const leftImageSrc = stim.trialType == 'something-same-1' ? stim.image[0] : stim.image;
    const leftPromptHtml = stim.trialType === 'something-same-2' ? `<p>${t[(0, helpers_1.camelize)(stim.audioFile[0])]}</p>` : '';
    const rightPromptHtml = stim.trialType === 'something-same-2'
        ? `<p>${t[(0, helpers_1.camelize)(stim.audioFile[1])]}</p>`
        : `<p>${t[(0, helpers_1.camelize)(stim.audioFile)]}</p>`;
    const leftImageHtml = `
    <button class='image-medium no-pointer-events' style="${stim.trialType == 'something-same-1' ? 'visibility: hidden;' : ''}">
      <img src=${__1.mediaAssets.images[(0, helpers_1.camelize)(leftImageSrc)]} alt=${leftImageSrc} />
    </button>
  `;
    // randomize choices if there is an answer
    const randomize = !!stim.answer ? 'yes' : 'no';
    const { choices } = (0, helpers_1.prepareChoices)(stim.answer, stim.distractors, randomize);
    const images = stim.trialType == 'something-same-1'
        ? stim.image.map((image) => {
            return `<img src=${__1.mediaAssets.images[(0, helpers_1.camelize)(image)]} alt=${image} />`;
        })
        : (0, exports.generateImageChoices)(choices);
    const rightImageHtml = `
    ${images
        .map((image) => {
        return `<button class='image-medium ${stim.trialType === 'something-same-1' ? 'no-pointer-events' : ''}' style='margin: 0 4px'>
                  ${image}
                </button>`;
    })
        .join('')}
  `;
    return `
    <div class="lev-stimulus-container-wide">
      ${(0, helpers_1.getParticipantUtilityButtonsHtml)(replayButtonHtmlId)}
      <div class="horizontal-wrapper">
        ${stim.trialType === 'something-same-2'
        ? `<div class="lev-row-container instruction-half-screen" id="left-prompt">`
        : `<div class="lev-row-container instruction-half-screen" style="visibility: hidden;">`}
          ${leftPromptHtml}
        </div>
        <div class="lev-row-container instruction-half-screen" id="right-prompt">
          <p>${rightPromptHtml}</p>
        </div>
      </div>
      <div class="horizontal-wrapper">
        <div class="lev-stim-content">
          ${leftImageHtml}
        </div>
        <div class="lev-stim-content" id="img-button-container">
          ${rightImageHtml}
        </div>
      </div>
      <div class="horizontal-wrapper" id="ok-button-container">
        <div class="lev-response-row multi-4">
        </div>
      </div>
    </div>
  `;
}
function handleButtonFeedback(btn, cards, isKeyBoardResponse, responsevalue, correctAudio) {
    var _a;
    const choice = ((_a = btn === null || btn === void 0 ? void 0 : btn.parentElement) === null || _a === void 0 ? void 0 : _a.id) || '';
    const answer = (0, taskStore_1.taskStore)().correctResponseIdx.toString();
    const isCorrectChoice = choice.includes(answer);
    let feedbackAudio;
    if (isCorrectChoice) {
        btn.classList.add('success-shadow');
        feedbackAudio = __1.mediaAssets.audio[correctAudio];
    }
    else {
        btn.classList.add('error-shadow');
        feedbackAudio = __1.mediaAssets.audio.feedbackTryAgain;
        // renable buttons
        setTimeout(() => enableBtns(cards), 500);
        incorrectPracticeResponses.push(choice);
    }
    function finishTrial() {
        taskSetup_1.jsPsych.finishTrial({
            response: choice,
            incorrectPracticeResponses,
            button_response: !isKeyBoardResponse ? responsevalue : null,
            keyboard_response: isKeyBoardResponse ? responsevalue : null,
        });
    }
    const correctAudioConfig = {
        restrictRepetition: {
            enabled: false,
            maxRepetitions: 2,
        },
        onEnded: finishTrial,
    };
    const incorrectAudioConfig = {
        restrictRepetition: {
            enabled: false,
            maxRepetitions: 2,
        },
    };
    helpers_1.PageAudioHandler.stopAndDisconnectNode(); // disconnect first to avoid overlap
    isCorrectChoice
        ? helpers_1.PageAudioHandler.playAudio(feedbackAudio, correctAudioConfig)
        : helpers_1.PageAudioHandler.playAudio(feedbackAudio, incorrectAudioConfig);
}
const stimulus = (trial) => {
    return {
        type: plugin_html_multi_response_1.default,
        data: () => {
            const stim = trial || (0, taskStore_1.taskStore)().nextStimulus;
            let isPracticeTrial = stim.assessmentStage === 'practice_response';
            return {
                save_trial: stim.assessmentStage !== 'instructions',
                assessment_stage: stim.assessmentStage,
                // not for firekit
                isPracticeTrial: isPracticeTrial,
            };
        },
        stimulus: () => {
            const stim = trial || (0, taskStore_1.taskStore)().nextStimulus;
            return stim.trialType.includes('something-same') ? getSomethingSameHtml(stim) : getTestDimensionsHtml(stim);
        },
        prompt_above_buttons: true,
        button_choices: () => {
            const stim = trial || (0, taskStore_1.taskStore)().nextStimulus;
            if (stim.trialType === 'test-dimensions') {
                const randomize = !!stim.answer ? 'yes' : 'no';
                // Randomize choices if there is an answer
                const { choices } = (0, helpers_1.prepareChoices)(stim.answer, stim.distractors, randomize);
                return (0, exports.generateImageChoices)(choices);
            }
            else {
                return ['OK'];
            }
        },
        button_html: () => {
            const stim = trial || (0, taskStore_1.taskStore)().nextStimulus;
            const buttonClass = stim.trialType === 'test-dimensions' ? 'image-medium' : 'primary';
            const buttonStyle = stim.trialType !== 'test-dimensions' ? 'margin: 16px' : '';
            return `<button class="${buttonClass}" style="${buttonStyle}">%choice%</button>`;
        },
        response_ends_trial: () => {
            const stim = trial || (0, taskStore_1.taskStore)().nextStimulus;
            return !(stim.trialType === 'test-dimensions' ||
                (stim.trialType === 'something-same-2' && stim.assessmentStage === 'practice_response'));
        },
        on_load: () => {
            var _a;
            startTime = performance.now();
            const stimulus = trial || (0, taskStore_1.taskStore)().nextStimulus;
            const audioFile = stimulus.audioFile;
            const trialType = stimulus.trialType;
            currentTrialId = stimulus.itemId;
            if (trialType === 'something-same-2') {
                // something-same-2 trials have multiple audio files
                const audioFiles = audioFile;
                const audioConfig = {
                    restrictRepetition: {
                        enabled: false,
                        maxRepetitions: 2,
                    },
                    onEnded: () => {
                        if (currentTrialId !== stimulus.itemId) {
                            return;
                        }
                        if (audioFiles.length) {
                            helpers_1.PageAudioHandler.playAudio(__1.mediaAssets.audio[(0, helpers_1.camelize)(audioFiles.shift())], audioConfig);
                        }
                    },
                };
                helpers_1.PageAudioHandler.playAudio(__1.mediaAssets.audio[(0, helpers_1.camelize)(audioFiles.shift())], audioConfig);
            }
            else {
                helpers_1.PageAudioHandler.playAudio(__1.mediaAssets.audio[(0, helpers_1.camelize)(audioFile)]);
            }
            const pageStateHandler = new helpers_1.PageStateHandler(audioFile, true);
            (0, helpers_1.setupReplayAudio)(pageStateHandler);
            (0, helpers_1.addExperimenterButtons)();
            (0, helpers_1.setupFullscreenButton)();
            const jspsychButtonContainer = document.getElementById('jspsych-html-multi-response-btngroup');
            jspsychButtonContainer.classList.add('lev-response-row');
            jspsychButtonContainer.classList.add('multi-4');
            if (trialType.includes('something-same')) {
                // widen the jspsych container so that the buttons are not squished
                const jsPsychHtmlMultiResponseContainer = document.getElementById('jspsych-html-multi-response-stimulus');
                jsPsychHtmlMultiResponseContainer.style.width = '100%';
                jsPsychHtmlMultiResponseContainer.style.display = 'flex';
                jsPsychHtmlMultiResponseContainer.style.justifyContent = 'center';
                const okButtonContainer = document.getElementById('ok-button-container');
                okButtonContainer.appendChild(jspsychButtonContainer);
            }
            if (trialType === 'something-same-2') {
                const leftPrompt = document.getElementById('left-prompt');
                const rightPrompt = document.getElementById('right-prompt');
                // equalize prompt box heights
                if (leftPrompt && rightPrompt) {
                    const styles = getComputedStyle(rightPrompt);
                    const paddingY = parseFloat(styles.paddingTop) + parseFloat(styles.paddingBottom);
                    const contentBoxHeight = rightPrompt.clientHeight - paddingY;
                    leftPrompt.style.height = `${contentBoxHeight}px`;
                }
                (0, helpers_1.disableOkButton)();
                const responseBtns = Array.from((_a = document.getElementById('img-button-container')) === null || _a === void 0 ? void 0 : _a.children);
                responseBtns.forEach((card, i) => {
                    card.addEventListener('click', () => {
                        var _a;
                        const answer = (_a = card.children[0]) === null || _a === void 0 ? void 0 : _a.alt;
                        if (!card) {
                            return;
                        }
                        if (card.classList.contains(SELECT_CLASS_NAME)) {
                            card.classList.remove(SELECT_CLASS_NAME);
                            selection = null;
                            selectionIdx = null;
                        }
                        else {
                            card.classList.add(SELECT_CLASS_NAME);
                            selection = answer;
                            selectionIdx = i;
                            responseBtns.forEach((card, j) => {
                                if (j !== i) {
                                    card.classList.remove(SELECT_CLASS_NAME);
                                }
                            });
                        }
                        if (selection !== null) {
                            (0, helpers_1.enableOkButton)();
                        }
                        else {
                            (0, helpers_1.disableOkButton)();
                        }
                        setTimeout(() => enableBtns(responseBtns), 500);
                    });
                });
                let numberOfErrors = 0;
                if (stimulus.assessmentStage === 'practice_response') {
                    const okButton = document.querySelector('.primary');
                    okButton.addEventListener('click', (e) => {
                        if (selectionIdx !== (0, taskStore_1.taskStore)().correctResponseIdx) {
                            const rightPrompt = document.getElementById('right-prompt');
                            const leftPrompt = document.getElementById('left-prompt');
                            rightPrompt.innerHTML = `<p>${(0, taskStore_1.taskStore)().translations.feedbackNotQuiteRight}</p>`;
                            leftPrompt.style.visibility = 'hidden';
                            numberOfErrors++;
                            const audioConfig = {
                                restrictRepetition: {
                                    enabled: false,
                                    maxRepetitions: 2,
                                },
                            };
                            helpers_1.PageAudioHandler.stopAndDisconnectNode();
                            helpers_1.PageAudioHandler.playAudio(__1.mediaAssets.audio.feedbackNotQuiteRight, audioConfig);
                            responseBtns.forEach((btn) => btn.classList.remove(SELECT_CLASS_NAME));
                            selection = null;
                            selectionIdx = null;
                            if (numberOfErrors >= 2) {
                                responseBtns[(0, taskStore_1.taskStore)().correctResponseIdx].style.animation = 'pulse 2s infinite';
                            }
                        }
                        else {
                            e.stopPropagation(); // prevents jspsych from disabling the buttons in the next trial
                            taskSetup_1.jsPsych.finishTrial();
                        }
                    });
                }
            }
            // if the task is running in a cypress test, the correct answer should be indicated with 'correct' class
            if (window.Cypress && trialType !== 'something-same-1') {
                const responseBtns = document.querySelectorAll('.image-medium');
                responseBtns.forEach((button) => {
                    var _a;
                    const imgAlt = (_a = button.querySelector('img')) === null || _a === void 0 ? void 0 : _a.getAttribute('alt');
                    if (imgAlt === (0, taskStore_1.taskStore)().nextStimulus.answer) {
                        button.classList.add('correct');
                    }
                });
            }
            if (trialType === 'test-dimensions') {
                // cards should give feedback during test dimensions block
                const practiceBtns = Array.from(jspsychButtonContainer.children)
                    .map((btnDiv) => btnDiv.firstChild)
                    .filter((btn) => !!btn);
                practiceBtns.forEach((card, i) => {
                    const eventType = taskSetup_1.isTouchScreen ? 'touchend' : 'click';
                    card.addEventListener(eventType, (e) => {
                        handleButtonFeedback(card, practiceBtns, false, i, 'feedbackGoodJob');
                    });
                });
            }
            (0, displayDebugInfo_1.displayDebugInfo)(stimulus);
        },
        on_finish: (data) => {
            helpers_1.PageAudioHandler.stopAndDisconnectNode();
            currentTrialId = '';
            const stim = trial || (0, taskStore_1.taskStore)().nextStimulus;
            const choices = (0, taskStore_1.taskStore)().choices;
            const endTime = performance.now();
            const cat = (0, taskStore_1.taskStore)().runCat;
            taskSetup_1.jsPsych.data.addDataToLastTrial({
                audioButtonPresses: helpers_1.PageAudioHandler.replayPresses,
            });
            // Always need to write correct key because of firekit.
            // TODO: Discuss with ROAR team to remove this check
            if (stim.assessmentStage !== 'instructions') {
                let isCorrect;
                if (stim.trialType === 'test-dimensions') {
                    // if no incorrect answers were clicked, that trial is correct
                    isCorrect = incorrectPracticeResponses.length === 0;
                }
                else {
                    isCorrect = selectionIdx === (0, taskStore_1.taskStore)().correctResponseIdx;
                }
                incorrectPracticeResponses = [];
                // don't update task store for something-same-1 trials
                if (stim.trialType !== 'something-same-1') {
                    // update task store
                    (0, taskStore_1.taskStore)('isCorrect', isCorrect);
                    if (isCorrect === false && stim.assessmentStage !== 'practice_response') {
                        taskStore_1.taskStore.transact('numIncorrect', (oldVal) => oldVal + 1);
                    }
                    else {
                        (0, taskStore_1.taskStore)('numIncorrect', 0);
                    }
                }
                taskSetup_1.jsPsych.data.addDataToLastTrial({
                    // specific to this trial
                    item: stim.item,
                    answer: stim.answer,
                    correct: isCorrect,
                    distractors: stim.distractors,
                    corpusTrialType: stim.trialType,
                    response: selection,
                    responseLocation: selectionIdx,
                    itemUid: stim.itemUid,
                    audioFile: stim.audioFile,
                    corpus: (0, taskStore_1.taskStore)().corpus,
                });
                if ((0, taskStore_1.taskStore)().storeItemId) {
                    taskSetup_1.jsPsych.data.addDataToLastTrial({
                        itemId: stim.itemId,
                    });
                }
                if (stim.trialType === 'test-dimensions' || stim.assessmentStage === 'practice_response') {
                    const calculatedRt = Math.round(endTime - startTime);
                    taskSetup_1.jsPsych.data.addDataToLastTrial({
                        rt: calculatedRt,
                    });
                }
                if (stim.assessmentStage === 'test_response') {
                    taskStore_1.taskStore.transact('testTrialCount', (oldVal) => oldVal + 1);
                }
                // if heavy instructions is true, show data quality screen before ending
                if ((0, taskStore_1.taskStore)().numIncorrect >= (0, taskStore_1.taskStore)().maxIncorrect && !(0, taskStore_1.taskStore)().heavyInstructions && !cat) {
                    (0, trials_1.finishExperiment)();
                }
                if (stim.trialType !== 'something-same-1' && stim.trialType !== 'instructions') {
                    (0, shouldTerminateCat_1.shouldTerminateCat)();
                    (0, helpers_2.updateTheta)(stim, isCorrect);
                }
                if (cat && !(stim.assessmentStage === 'practice_response')) {
                    (0, shouldTerminateCat_1.shouldTerminateCat)();
                    const allSequentialTrials = (0, taskStore_1.taskStore)().sequentialTrials;
                    const nextTrials = allSequentialTrials.filter((trial) => {
                        return trial.trialNumber === stim.trialNumber && trial.block_index === stim.block_index;
                    });
                    (0, helpers_1.selectNextSequentialTrial)(nextTrials);
                }
            }
            if (stim.trialType === 'test-dimensions' || stim.assessmentStage === 'practice_response') {
                const calculatedRt = Math.round(endTime - startTime);
                taskSetup_1.jsPsych.data.addDataToLastTrial({
                    rt: calculatedRt,
                });
            }
            if (stim.assessmentStage === 'test_response') {
                taskStore_1.taskStore.transact('testTrialCount', (oldVal) => oldVal + 1);
            }
        },
    };
};
exports.stimulus = stimulus;
